module.exports = __webpack_public_path__ + "toGroom-we-y-b.313adc24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-y-b.jpg
// module id = tt8x
// module chunks = 0